import React, { useState, useCallback, useEffect, useMemo } from "react";
import swal from "sweetalert";
import DataTable from "react-data-table-component";
import { identityAPI } from "../../api/skillm";
import { getAllIdentity } from "../../api/common";
import * as XLSX from "xlsx";

const IdentityMatrix = () => {
  const [identity, setIdentity] = useState([]);

  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const [reqParams, setReqParams] = useState({
    page: currentPage,
    limit: perPage,
  });

  const [fetch, setFetch] = useState(true);

  const fetchUsers = useCallback(
    (params) => {
      let query = new URLSearchParams(params).toString();
      setLoading(true);
      identityAPI(query)
        .then((res) => {
          setData(res?.data);
          setTotalRows(res?.total);
          setLoading(false);
          setFetch(false);
        })
        .catch((err) => {
          swal("Error", err?.message, "error");
          setLoading(false);
          setFetch(false);
        });
    },
    [setFetch]
  );

  const fetchIdenties = useCallback(async () => {
    let identites = await getAllIdentity();
    setIdentity(identites);
    let identityClm = [
      {
        name: "Skills",
        selector: (row) => row.skill_title,
        width: "250px",
        wrap: true,
      },
    ];
    identites.forEach((identity) => {
      identityClm.push({
        name: identity.identify_name,
        selector: (row) =>
          row[identity.identify_name] ? row[identity.identify_name] : 0,
        width: "200px",
        wrap: true,
      });
    });
    setColumns(identityClm);
  }, []);

  useEffect(() => {
    fetchIdenties();
  }, []);

  useEffect(() => {
    if (fetch) {
      fetchUsers(reqParams);
    }
  }, [fetch, reqParams, fetchUsers]);

  const handlePageChange = useCallback(
    (page) => {
      setCurrentPage(page);
      setReqParams({
        ...reqParams,
        page: page,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handlePerRowsChange = useCallback(
    async (newPerPage, page) => {
      setPerPage(newPerPage);
      setReqParams({
        ...reqParams,
        limit: newPerPage,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  //   const fetchData = async () => {
  //     let da = await getAllIdentity();
  //     setIdentity(da);
  //   };

  const downloadExcel = () => {
    // Prepare the data for Excel export
    const worksheetData = data.map((d) => {
      const row = { Skill: d.skill_title };
      identity.forEach((identityItem, index) => {
        row[identityItem.identify_name] = d[identityItem.identify_name]
          ? d[identityItem.identify_name]
          : 0;
      });
      return row;
    });

    // Convert to worksheet
    const worksheet = XLSX.utils.json_to_sheet(worksheetData);

    // Create a new workbook and add the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Identity Matrix");

    // Save the file
    XLSX.writeFile(workbook, "IdentityMatrix.xlsx");
  };

  return (
    <>
      <div className="d-flex justify-content-between mb-3">
        <button className="btn btn-primary" onClick={downloadExcel}>
          Download Excel
        </button>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="table-responsive">
            <DataTable
              className="table display dataTablesCard job-table table-responsive-xl card-table dataTable no-footer"
              columns={columns}
              data={data}
              progressPending={loading}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              persistTableHead
              sortServer
              fixedHeader={true}
              fixedHeaderScrollHeight={"500px"}
            />
            {/* <table className="table display mb-4 dataTablesCard Plan-table table-responsive-xl card-table dataTable no-footer">
              <thead>
                <tr>
                  <th>Skill</th>
                  {identity?.map((item) => {
                    return (
                      <>
                        <th>{item.identify_name}</th>
                      </>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {data?.map((d, index) => (
                  <tr key={index}>
                    <td>{d.skill_title}</td>
                    {d?.identifies?.map((item) => {
                      return (
                        <>
                          <td>{item.candidates}</td>
                        </>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default IdentityMatrix;
